import React from 'react'

function QuotesIcon({ width = 34, height = 24 }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 34 24"
      fill="currentColor"
    >
      <path d="M10.7368 24H0L10.1053 0H16.9474L10.7368 24ZM27.7895 24H17.0526L27.1579 0H34L27.7895 24Z" />
    </svg>
  )
}

export default QuotesIcon
